<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading"
           @on-cancel="cancel"
           :width="620"
    >
      <h3 slot="header" class="modal-header">作废预订单</h3>

      <div>

        <div class="mb32">{{this.title}}</div>

        <Form :label-width="120" :rules="formRules" :model="formData" ref="formdata">
          <FormItem label="违约方:"  prop="defaultParty">
            &nbsp;&nbsp; <Select class="width3" v-model="formData.defaultParty" @on-change="changeDefaultParty">
            <Option v-for="(item,index) in defaultPartyList" :value="item.value" :key="'keyA'+index">{{item.text}}</Option>
          </Select>
          </FormItem>

          <FormItem label="订金退还:" >
            &nbsp;&nbsp;<Input class="width3" v-model="this.depositAccount" disabled="disabled"></Input>
          </FormItem>
          <FormItem label="扣除客户违约金:" prop="defaultDiscount" v-if="formData.defaultParty === 1">
            -&nbsp;<Input class="width3" v-model="formData.defaultDiscount" @on-blur="calculation"></Input> 元
          </FormItem>
          <FormItem label="合计退款:" prop="totalRefund">
            &nbsp;&nbsp;<Input class="width3" v-model="formData.totalRefund" readonly="readonly"></Input> 元
          </FormItem>
        </Form>
        <span class="grey">- - - - - - - - - - - - - - - - - - - - - - -</span>
        <div v-if="this.userType === 3">
          <h4 class="mb16">客户储蓄账户信息</h4>
          <div>

            <Row class="row" :gutter="16">
              <Col span="8">开户行名称</Col>
              <Col span="8">银行账号</Col>
              <Col span="8">开户人姓名</Col>
            </Row>

            <Row class="row" :gutter="16">
              <Col span="8">
                <Select class="width80"
                        v-model="countParams.bankName"
                        :filterable="true"
                        style="text-align: left"
                >
                  <Option value="">请选择</Option>
                  <Option v-for="(item,index) in bankList" :value="item.bankName" :key="'keyX'+index">{{item.bankName}}</Option>
                </Select>
              </Col>
              <Col span="8">
                <Input class="width80" v-model="countParams.bankAccount"/>
              </Col>
              <Col span="8">
                <Input class="width80" v-model="countParams.accountName"/>
              </Col>
            </Row>
          </div>
        </div>
        <div class="mt36">{{this.refundWayStr}}</div>

      </div>
    </Modal>
  </div>
</template>
<script>
  import {invalidDetail,orderinvalid} from "../../../../../api/book";
  import {getbankInfo} from "../../../../../api/book";

  export default {
    name: "",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      reservationOrderFid:{
        type:String,
        default:''
      }
    },
    watch: {
      n() {
        this.detail();
        this.formData.defaultParty = -1
      }
    },
    data() {
      return {
        formData:{
          "defaultDiscount": 0,
          "defaultParty": -1,
          "reservationOrderFid": 0,
          "totalRefund": 0
        },
        formRules: {
          defaultDiscount: [
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber2}

          ],
          defaultParty: [
            {required: true, message: ' ', trigger: 'blur', validator: this.validateNumber}
          ],
          totalRefund: [
            {required: true, message: ' ', trigger: 'blur',  validator: this.validateNumber2}
          ]
        },
        bankList:[],
        defaultPartyList:[{text:'请选择',value:-1},{text:'公司',value:0},{text:'客户',value:1}],
        loading: true,
        isShow: false,
        depositAccount:0,
        userType:1,
        refundWayStr:'',//退款途径文案
        title:'',//头部提示信息
        countParams: {
          bankName: '',
          bankAccount: '',
          accountName: '',
          costRemark: ''
        },
        // formRules2: {
        //   bankName: [
        //     {required: true, message: '', trigger: 'blur', type: 'string'}
        //
        //   ],
        //   bankAccount: [
        //     {required: true, message: '', trigger: 'blur', validator: this.validateNumber}
        //   ],
        //   accountName: [
        //     {required: true, message: '', trigger: 'blur', type: 'string'}
        //   ]
        // },

      }
    },
    methods: {
      validateNumber2(rule, value, callback) {
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      detail(){
        if(!this.reservationOrderFid){
          return
        }
        invalidDetail(this.reservationOrderFid).then(res=>{
          this.isShow = true
          this.depositAccount = res.data.depositAccount
          this.formData.totalRefund = res.data.depositAccount
          this.refundWayStr = res.data.refundWayStr
          this.title = res.data.title
          this.userType = res.data.userType
          if(res.data.userType === 3){
            this.countParams.bankName = res.data.customerBankName
            this.countParams.bankAccount = res.data.customerAccountName
            this.countParams.accountName = res.data.customerBankAccount
          }
        }).catch(error=>{
          this.isShow = false
        })

      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      changeDefaultParty(){
        this.formData.defaultDiscount = 0;
        this.formData.totalRefund = parseFloat(this.depositAccount - this.formData.defaultDiscount).toFixed(2);
      },
      calculation(){
        let pattern = /^(\d+)(\.\d+)?$/
        if (!pattern.test(this.formData.defaultDiscount)) {
          this.$Message.error('请输入正确的数字')
          this.formData.defaultDiscount = 0
        }
        // this.formData.defaultDiscount = parseInt(this.formData.defaultDiscount)
        this.formData.defaultDiscount = Number(this.formData.defaultDiscount).toFixed(2)
        // this.formData.totalRefund = parseInt(this.depositAccount - this.formData.defaultDiscount)
        this.formData.totalRefund = (this.depositAccount - this.formData.defaultDiscount).toFixed(2)
        if(this.formData.totalRefund < 0){
          this.$Message.error('合计退款不能为负数')
          this.formData.defaultDiscount = 0
          // this.formData.totalRefund = parseInt(this.depositAccount - this.formData.defaultDiscount)
          this.formData.totalRefund = (this.depositAccount - this.formData.defaultDiscount).toFixed(2)
        }
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      ok() {
        // this.$refs['formdata']&& this.$refs['formdata'].validate(bool=>{

        if(this.formData.defaultParty === -1){
          this.$Message.error('请选择违约方')
          this.changeLoading()
          return
        }

        this.$Modal.confirm({
          title: '付款作废',
          content: '<p>本次退款金额' + this.formData.totalRefund + '元，继续操作将直接完成付款，此操作不可逆，请确认无误后继续。</p>',
          onOk: () => {
            let params={
              "fid": this.reservationOrderFid,
              "totalRefund": this.formData.totalRefund,
              "customerBankName": this.countParams.bankName,
              "customerAccountName": this.countParams.bankAccount,
              "customerBankAccount": this.countParams.accountName,
              "defaultParty": this.formData.defaultParty
            }
            orderinvalid(params).then(res=>{
              this.$Message.success('操作成功')
              this.$emit('getData')
              this.isShow=false
            }).catch(error=>{
              this.changeLoading()
            })
          }
        })

        // })

      },
      cancel() {

      }
    },
    created() {
      getbankInfo().then(res=>{
        if(res.data) {
          this.bankList = res.data
        }
      }).catch(err=>{})
    }

  }
</script>

<style scoped>
  .width3{
    width: 220px;
  }
  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }
  .grey{
    color:grey;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }
</style>
